import { httpRequest } from "@services/http";
import { AudienceDefinition } from "@models/audienceDefinition.model";
import { AudienceDefinitionSerializer } from "@models/serializers/audienceDefinitionSerializer";

export interface UpdateAudiencePayload {
  name?: string;
  description?: string | null;
  rules?: Record<string, any>;
  audience_preset_id?: number | null;
}

export class CommandUpdateAudienceDefinition {
  async run(audienceId: number, payload: UpdateAudiencePayload): Promise<AudienceDefinition> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/audiences/${audienceId}/`;
    const response = await httpRequest<any>(url, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });

    const serializer = new AudienceDefinitionSerializer();
    return serializer.deserialize(response);
  }
}